// Lampu suar berkedip (menara pemancar, puncak gedung tinggi) — dilukis per frame di atas selubung malam.
// Deklaratif: def.suar = [{ u, v, z, warna?, periode? }] (u,v relatif tapak 0..1; z dalam satuan tile T).
import { TILE_W } from "./iso";

export function drawSuar(ctx, state, defs, gridToScreen, cam, atmos, at, W, H) {
  const ni = Math.max(0, (atmos.dark - 0.15) / 0.85);   // 0 siang → 1 malam
  if (ni <= 0) return;
  const byId = {};
  for (const d of defs || []) if (Array.isArray(d.suar) && d.suar.length) byId[d.bid] = d;
  const T = TILE_W * cam.zoom;
  ctx.save();
  ctx.globalCompositeOperation = "lighter";
  let idx = 0;
  for (const b of state.buildings || []) {
    const def = byId[b.bid];
    if (!def) continue;
    let w = def.w || 1, h = def.h || 1;
    const rot = b.rot || 0;
    if (rot % 2 === 1) [w, h] = [h, w];
    const c = [gridToScreen(b.x, b.y), gridToScreen(b.x + w, b.y), gridToScreen(b.x + w, b.y + h), gridToScreen(b.x, b.y + h)];
    const [top, right, , left] = [0, 1, 2, 3].map(i => c[(i + rot) % 4]);
    for (const s of def.suar) {
      const x = top[0] + s.u * (right[0] - top[0]) + s.v * (left[0] - top[0]);
      const y = top[1] + s.u * (right[1] - top[1]) + s.v * (left[1] - top[1]) - (s.z || 0) * T;
      if (x < -40 || x > W + 40 || y < -40 || y > H + 40) continue;
      // denyut pelan: naik cepat, meredup perlahan; fase digeser per bangunan agar tidak serempak
      const periode = s.periode || 2.4, fase = ((at + (b.x * 0.37 + b.y * 0.53 + idx * 0.11)) % periode) / periode;   // at = detik animasi
      const k = Math.pow(Math.max(0, Math.sin(fase * Math.PI)), 3);
      const col = s.warna || "255,60,60";
      const r = Math.max(2, 0.03 * T);
      const g = ctx.createRadialGradient(x, y, 0, x, y, r * (3 + 2 * k));
      g.addColorStop(0, `rgba(${col},${(0.55 * ni * (0.35 + 0.65 * k)).toFixed(3)})`);
      g.addColorStop(0.35, `rgba(${col},${(0.22 * ni * k).toFixed(3)})`);
      g.addColorStop(1, `rgba(${col},0)`);
      ctx.fillStyle = g;
      ctx.beginPath(); ctx.arc(x, y, r * (3 + 2 * k), 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = `rgba(255,${Math.round(60 + 140 * k)},${Math.round(60 + 140 * k)},${(ni * (0.15 + 0.75 * k)).toFixed(3)})`;
      ctx.beginPath(); ctx.arc(x, y, r * (0.45 + 0.35 * k), 0, Math.PI * 2); ctx.fill();
      idx++;
    }
  }
  ctx.restore();
}
